export * from 'server/models/User';


// WEBPACK FOOTER //
// ./data/models/User.ts